import { z } from 'zod';

export const TimelyAllowedSideEffectSchema = z.enum(['project_templates']);
export type TimelyAllowedSideEffect = z.infer<typeof TimelyAllowedSideEffectSchema>;

export const TIMELY_ALLOWED_SIDE_EFFECT_PROJECT_TEMPLATES =
  'project_templates' satisfies TimelyAllowedSideEffect;

export const TimelyAllowedSideEffectsSchema = z
  .array(TimelyAllowedSideEffectSchema)
  .describe('Timely side effects this resource is explicitly allowed to trigger');
